import i18nFactory from '@yandex-int/i18n';
import * as React from 'react';

import { ModalDecorator } from '../../../../components/ModalDecorator/ModalDecorator';
import { StyledLink, StyledLinkTheme } from '../../../../components/StyledLink/StyledLink';
import { Bem } from '../../../../service/Bem/Bem';

import './LongUploadPopup.css';
import * as keyset from './LongUploadPopup.i18n';

const i18n = i18nFactory(keyset);

export interface LongUploadPopupProps {
    isVisible: boolean;
    isVideoAddition?: boolean;
    onClose: () => void;
}

const BLOCK = 'long-upload-popup';

export const LongUploadPopup = React.memo(({ isVisible, isVideoAddition, onClose }: LongUploadPopupProps) => (
    <ModalDecorator visible={isVisible} cls={BLOCK}>
        <div className={Bem.cls(BLOCK, 'progress')} />
        <div className={Bem.cls(BLOCK, 'text')}>
            {i18n('long-upload-message-start')}
            <br />
            {isVideoAddition ? i18n('long-upload-message-addition') : i18n('long-upload-message-creative')}
            <br />
            {i18n('long-upload-message-end')}
        </div>
        <StyledLink theme={StyledLinkTheme.blue} onClick={onClose}>
            {i18n('long-upload-accept-link')}
        </StyledLink>
    </ModalDecorator>
));
